import type { PageLoad } from './$types';
import shopify from '$lib/api/ecom/shopify';
import { error } from '@sveltejs/kit';
import { gqlClient, injectTranslations } from '$lib/util/directus';
import { queryProductPage } from '$lib/api/queries';
import { getPage, getPreviewHeader, getSpecialPage } from '$lib/util/pagebuilder';
import { handleRedirect } from '$lib/util/redirects';
import { redirect } from '@sveltejs/kit';

export const load: PageLoad = async ({ parent, params }) => {
  const p = await parent();

  const lang: string = params.lang;
  const previewHeader = getPreviewHeader()

  handleRedirect(params.path, p.redirects)

  const [maxPrice, collections] = await Promise.all([
    shopify.getMostExpensiveProducts(p.location),
    shopify.getCollections(params.lang)
  ]);

  const slug = params.slug ?? 'all'

  let collection = null

  for (const c of collections.collections?.edges ?? []) {
    if (c.node.handle === slug) {
      collection = c.node
      break
    }
    if (c.node.id === 'gid://shopify/Collection/' + slug) {
      redirect(301, '/' + params.lang + '/' + params._shop + '/' + (c.node?.handle ?? ''));
    }
  }

  if (collection) {
    const previewHeader = getPreviewHeader()
    const page = await getPage({ path: 'shop', lang: params.lang }, { customerType: p.customerType, data: p }, previewHeader);

    return {
      maxPrice: Math.ceil(parseFloat(maxPrice?.products?.edges?.[0]?.node?.priceRange?.maxVariantPrice?.amount ?? 10000)),
      collections: collections?.collections?.edges,
      collection,
      page
    }
  }

  const [product, productsById, additionalData] = await Promise.all([
    shopify.getProductByHandle(params.slug, p.location, params.lang),
    shopify.getProductsById(['gid://shopify/Product/' + params.slug], p.location, params.lang),
    injectTranslations(
      await gqlClient.request(queryProductPage(params.slug, params.lang), {}, previewHeader),
      lang
    )
  ])
  if (!product || product.product_type.value !== p.customerType) {
    const productById = productsById?.nodes?.[0] ?? null

    if (productById) {
      redirect(301, '/' + params.lang + '/' + params._shop + '/' + (productById?.handle ?? ''));
    } else {
      error(404, 'Not found');
    }
  }

  const globalProductSections = await getSpecialPage('product', { path: 'shop', lang: params.lang }, { product: product, data: p }, previewHeader)

  return {
    product,
    additionalData: additionalData?.products?.[0],
    globalProductSections
  }
};